

<mat-progress-bar mode="indeterminate" *ngIf="!loaded" class="progress-bar"></mat-progress-bar>
<div id="gjs" #gjs>

</div>
